// extracted by mini-css-extract-plugin
export var flexibleBaseContentModel = "fp-Bt";
export var flexibleBaseContentModelAuthorBottom = "fp-Ot";
export var flexibleBaseContentModelAuthorTop = "fp-Nt";
export var flexibleBaseContentModelAuthor__body = "fp-Pt";
export var flexibleBaseContentModelAuthor__desc = "fp-Wt";
export var flexibleBaseContentModelAuthor__header = "fp-Rt";
export var flexibleBaseContentModelAuthor__img = "fp-Tt";
export var flexibleBaseContentModelAuthor__imgWrapper = "fp-St";
export var flexibleBaseContentModelAuthor__info = "fp-Qt";
export var flexibleBaseContentModelAuthor__link = "fp-Xt";
export var flexibleBaseContentModelAuthor__name = "fp-Ut";
export var flexibleBaseContentModelAuthor__title = "fp-Vt";
export var flexibleBaseContentModel__body = "fp-Ct";
export var flexibleBaseContentModel__content = "fp-Dt";
export var flexibleBaseContentModel__featured = "fp-It";
export var flexibleBaseContentModel__featured__card = "fp-Lt";
export var flexibleBaseContentModel__featured__cardImg = "fp-Kt";
export var flexibleBaseContentModel__featured__header = "fp-Jt";
export var flexibleBaseContentModel__header = "fp-Et";
export var flexibleBaseContentModel__header__title = "fp-Ft";
export var flexibleBaseContentModel__header__widget = "fp-Gt";
export var flexibleBaseContentModel__videoWrapper = "fp-Mt";
export var flexibleBaseContentModel__widgets = "fp-Ht";
export var mt0 = "fp-ut";
export var mt1 = "fp-vt";
export var mt2 = "fp-wt";
export var mt3 = "fp-xt";
export var mt4 = "fp-yt";
export var mt5 = "fp-zt";
export var mt6 = "fp-At";